import { Component, OnInit, ViewChild, HostListener, ElementRef, OnDestroy, AfterViewInit, NgZone } from '@angular/core';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { FileExplorerService } from 'app/services/file-explorer.service';
import { MyFile } from "app/models/my-file";
import { HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService, ModalDirective, MDBModalService } from 'ng-uikit-pro-standard';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { finalize } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { ClipboardService, FilesClipboardServiceFactory } from 'app/services/clipboard.service';
import { Clipboard } from 'app/models/clipboard';
import { Resumable, ResumableFile } from 'resumablejs';
import { FileComment } from 'app/models/file-comment';
import { UserService } from 'app/services/user.service';
import { StorageService } from 'app/services/storage.service';
import { Location } from '@angular/common';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { WopiService } from 'app/services/wopi.service';
import { FileToUpload } from 'app/models/file-to-upload';
import { FileClass } from 'app/models/file-class';
import { FileClassService } from 'app/services/file-class.service';
import { Form } from '@atefhashem/eforms';
import { FileVersion } from 'app/models/file-version';
import { ConnectedAppAuth } from 'app/models/connected-app';
import { ConnectedAppAuthorizeComponent } from 'app/views/connected-apps/connected-app-authorize/connected-app-authorize.component';
import { MetadataEditorComponent } from 'app/views/metadata-editor/metadata-editor.component';
import { EditableMetadataInterface } from 'app/models/editable-metadata-interface';
import { trimEnd } from 'lodash';
import { FeatureTrialLockModalComponent } from 'app/views/feature-trial-lock-modal/feature-trial-lock-modal.component';

@Component({
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss'],
  providers: [
    {
      provide: ClipboardService,
      useFactory: FilesClipboardServiceFactory
    }
  ]
})
export class FileExplorerComponent implements OnInit, OnDestroy, AfterViewInit {
  storageId: number = 0;
  currentPath: { path: string, dirname: string }[] = [];

  filesLoadingIndicator: boolean = true;
  addComment: string;
  updatecomment: boolean = false;
  totalUploadedPercent: number = 0;
  // status will be 0 for uploading, 1 for success, 2 for failed, 3 for waiting
  filesUploadStatus: { fileId?: string, fileName: string, percent: number, loaded: number, status: number }[] = [];
  numCompletedUploads: number = 0;
  numErrorUploads: number = 0;
  currentStorageName: string = 'My Files';
  isEcoDocsStorage: boolean = false;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedFilesToUploadTableLimit: number = 20;
  selectedTableLimit: number = 20;
  selectedUploadingTableLimit: number = 20;

  ocrTextContent: string = '';
  isLoadingTextContent: boolean = false;

  files: MyFile[] = [];
  selectedRows: MyFile[] = [];

  isCreatingFolder: boolean = false;
  isRenamingFolder: boolean = false;
  isSearchOpen: boolean = false;
  hasClipboard: boolean = false;
  isCreatingZip: boolean = false;

  createNewFolderForm: FormGroup;
  renameFileForm: FormGroup;
  createNewZipForm: FormGroup;

  searchText: string = '';
  searchInContent: boolean = true;

  canDeletePermission: boolean = false;
  canWritePermission: boolean = false;
  canReadPermission: boolean = false;
  isGlobalStorage: boolean = false;

  resumable: Resumable;

  filesToUpload: FileToUpload[] = [];
  selectedFilesToUpload: FileToUpload[] = [];

  filesToEditMetadata: EditableMetadataInterface[] = [];

  fileClasses: FileClass[] = [];
  currentFileClass: FileClass = null;
  currentMetadataForm: Form = null;
  isMetadataValid: boolean = true;

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('fileUploadMetadataEditor', { static: true }) fileUploadMetadataEditor: MetadataEditorComponent;
  @ViewChild('existingFilesMetadataEditor', { static: true }) existingFilesMetadataEditor: MetadataEditorComponent;
  @ViewChild('ocrTextModal', { static: true }) ocrTextModal: ModalDirective;
  @ViewChild('filesToUploadModal', { static: true }) filesToUploadModal: ModalDirective;
  @ViewChild('editMetadataModal', { static: true }) editMetadataModal: ModalDirective;
  @ViewChild('createFolderModal', { static: true }) createFolderModal: ModalDirective;
  @ViewChild('deleteConfirmationModal', { static: true }) deleteConfirmationModal: ModalDirective;
  @ViewChild('renameFileModal', { static: true }) renameFileModal: ModalDirective;
  @ViewChild('createZipModal', { static: true }) createZipModal: ModalDirective;
  @ViewChild('fileUploadingModal', { static: true }) fileUploadingModal: ModalDirective;
  @ViewChild('cancelUploadConfirmationModal', { static: true }) cancelUploadConfirmationModal: ModalDirective;
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  @ViewChild('commentEditor') commentEditor;
  @ViewChild('MyDropZone', { static: false }) MyDropZone: ElementRef;
  @ViewChild('versionHistoryModal', { static: true }) versionHistoryModal: ModalDirective;
  @ViewChild('authorizeApp') authorizeApp: ConnectedAppAuthorizeComponent;

  currentFileHistory: FileVersion[] = [];
  isLoadingVersionHistory: boolean = false;

  isCheckingExtOpAuth: boolean = false;
  
  muliSelectionOptions = [
    /*{
      label: 'Star',
      action: () => {
        console.log('clicked')
      }
    },*/
    {
      label: 'Cut',
      action: () => this.onMoveOrCopyFile('cut'),
      isEnabled: this.canMove.bind(this)
    },
    {
      label: 'Copy',
      action: () => this.onMoveOrCopyFile('copy'),
      isEnabled: this.canCopy.bind(this)
    },
    {
      label: 'Delete',
      action: () => {
        this.showDeleteConfirmation();
      },
      isEnabled: this.canDelete.bind(this)
    },
    /*{
      label: 'Download',
      action: () => this.onDownloadFile()
    },*/
    {
      label: 'Metadata',
      action: () => {
        this.onEditExistingMetadata();
      },
      isEnabled: this.canEditMetadata.bind(this)
    },
    {
      label: 'Compress to ZIP',
      action: () => {
        this.showCompressModal();
      },
      isEnabled: this.canCompress.bind(this)
    },
  ]

  folderOptions = [
    {
      label: 'Open',
      action: () => this.onFolderRightClickOpen(),
      isEnabled: () => this.canReadPermission
    },
    {
      label: 'Cut',
      action: () => this.onMoveOrCopyFile('cut'),
      isEnabled: this.canMove.bind(this)
    },
    {
      label: 'Copy',
      action: () => this.onMoveOrCopyFile('copy'),
      isEnabled: this.canCopy.bind(this)
    },
    {
      label: 'Delete',
      action: () => this.showDeleteConfirmation(),
      isEnabled: this.canDelete.bind(this)
    },
    {
      label: 'Rename',
      action: () => this.onFileRenaming(),
      isEnabled: this.canRename.bind(this)
    },
    {
      label: 'Download',
      action: () => this.onDownloadFile(),
      isEnabled: () => this.canReadPermission
    },
    /*{
      label: 'Share',
      action: () => {
        console.log('clicked')
      },
      isEnabled: () => true
    },
    {
      label: 'Star',
      action: () => {
        console.log('clicked')
      }
    },*/
  ]

  fileOptions = [
    // {
    //   label: 'Open',
    //   action: () => {
    //     console.log('clicked')
    //   }
    // },
    {
      label: 'Cut',
      action: () => this.onMoveOrCopyFile('cut'),
      isEnabled: this.canMove.bind(this)
    },
    {
      label: 'Copy',
      action: () => this.onMoveOrCopyFile('copy'),
      isEnabled: this.canCopy.bind(this)
    },
    {
      label: 'Delete',
      action: () => this.showDeleteConfirmation(),
      isEnabled: this.canDelete.bind(this)
    },
    {
      label: 'Rename',
      action: () => this.onFileRenaming(),
      isEnabled: this.canRename.bind(this)
    },
    {
      label: 'Metadata',
      action: () => this.onEditExistingMetadata(),
      isEnabled: this.canEditMetadata.bind(this)
    },
    {
      label: 'Download',
      action: () => this.onDownloadFile(),
      isEnabled: () => this.canReadPermission
    },
    /*{
      label: 'Share',
      action: () => {
        console.log('clicked')
      },
      isEnabled: () => true
    },
    {
      label: 'Follow',
      action: () => {
        console.log('clicked')
      }
    },*/
    /*{
      label: 'Version History',
      action: () => {
        this.versionHistoryModal.show();
      }
    },*/
    /*{
      label: 'Star',
      action: () => {
        console.log('clicked')
      }
    },*/
    {
      label: 'Compress to ZIP',
      action: () => {
        this.showCompressModal();
      },
      isEnabled: this.canCompress.bind(this)
    },
    /*{
      label: 'Convert to PDF',
      action: () => {
        console.log('clicked')
      }
    }*/
    // {
    //   label: 'Workflows',
    //   subMenu: [
    //     {
    //       label: 'workflow 1',
    //       action: () => {
    //         console.log('clicked')
    //       }
    //     },
    //     {
    //       label: 'workflow 2',
    //       action: () => {
    //         console.log('clicked')
    //       }
    //     }
    //   ]
    // },

  ];

  newFileOptions = [
    {
      label: 'New Folder',
      action: () => {
        this.createFolderModal.show()
      },
      isEnabled: () => this.canWritePermission
    },
    {
      label: 'Upload File(s)',
      action: () => this.openFileDialog(),
      isEnabled: () => this.canWritePermission
    }
  ]

  isContextOpen: boolean = false;
  contextTop: number = 0;
  contextLeft: number = 0;
  contextOptions: any[] = [];
  showFileOverView: boolean = false;
  rightSideContext: any[] = [];
  dragFile: boolean = false;
  isDragLeaving: boolean = false; // workaround for drag zone being renabled instantly when the mouse is leaving the drag zone

  avatarRandomizer: number = 1;
 
  hideQuillToolbar: boolean = true;
  comments: FileComment[] = [];
  selectedcomment: any;

  filesMetadataCache: {[key: string]: {[key: string]: string|Date|number}} = {};
  isLoadingMetadata: boolean = false;
  currentMetadata: {[key: string] : string|number|Date} = null;

  wopiConfig: any = {};

  constructor(public fileService: FileExplorerService, private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder,
    private validationHandler: ValidationHandler, private toastService: ToastService, 
    private filesClipboardService: ClipboardService, public userService: UserService,
    private wopiService: WopiService, private fileClassService: FileClassService,
    private storageService: StorageService, private ngZone: NgZone, private router: Router,private ecoDocsTitleService: EcoDocsTitleService,
    private modalService: MDBModalService) {
        
    this.createNewFolderForm = this.formBuilder.group({
      folder_name: ['', [Validators.required, this.fileService.illegalFolderCharsValidator]]
    });

    this.renameFileForm = this.formBuilder.group({
      dest_path: ['', Validators.required]
    });

    this.createNewZipForm = this.formBuilder.group({
      zip_path: ['', Validators.required]
    });

    this.modulesOptions = {
      toolbar: this.toolbarOptions
    }

    this.wopiService.getWopiConfig().subscribe((c) => this.wopiConfig = c);

    this.avatarRandomizer = Math.random() * 10000000000;

    this.resumable = new Resumable({});

    this.userService.currentUser.subscribe(() => {
        this.resumable.opts.headers = { Authorization: `Bearer ${this.userService.access_token}` };
    });

    this.resumable.opts.query = function (file: ResumableFile) {
      return file['extraQueryParams'];
    };

    var that = this;
    this.resumable.opts.generateUniqueIdentifier = function () {
      var file: any = arguments[0];
      var relativePath = file.webkitRelativePath || file.relativePath || file.fileName || file.name; // Some confusion in different versions of Firefox
      var size = file.size;

      let lastDir = '/';
      if (that.currentPath.length != 0) {
        lastDir = trimEnd(that.currentPath[that.currentPath.length - 1].path, '/') + '/';
      }
      lastDir =  lastDir;

      var id = (size + '-' + (lastDir + '-' + relativePath).replace(/[^0-9a-zA-Z_-]/img, ''));
      return id;
    };

    this.resumable.on('fileAdded', (file: ResumableFile) => {
      this.filesToUpload.push({
        resumableFile: file
      });
      this.filesToUpload = [...this.filesToUpload];

      if (!this.userService.currentUserValue.subscription_status.is_subscribed &&
        !this.userService.currentUserValue.subscription_status.trial_active) {
          this.modalService.show(FeatureTrialLockModalComponent, {
            ignoreBackdropClick: true,
            backdrop: false,
            animated: true,
            containerClass: 'modal fade',
            class: 'modal-dialog modal-danger modal-notify',
            data: {
            }
          });
          return;
      }
  
      this.filesToUploadModal.show();
    });

    this.resumable.on('uploadStart', () => {
      this.fileUploadingModal.show();
    });

    this.resumable.on('complete', () => {
      this.getAllFiles();
      this.cancelUpload();
    });

    this.resumable.on('error', (message: string, file: ResumableFile) => {
      this.toastService.error('Error Uploading File: ' + file.fileName);
    });

    this.resumable.on('fileProgress', (file: ResumableFile) => {
      this.totalUploadedPercent = Math.trunc(this.resumable.progress() * 100);

      const index = this.filesUploadStatus.findIndex(f => f.fileId === file.uniqueIdentifier);
      if (index != -1) {
        this.filesUploadStatus[index].percent = Math.trunc(file.progress(false) * 100);
        this.filesUploadStatus[index].status = 0;
        this.ngZone.run(() => this.filesUploadStatus = [...this.filesUploadStatus]);
      }
    });

    this.resumable.on('fileSuccess', (file: ResumableFile) => {
      const index = this.filesUploadStatus.findIndex(f => f.fileId === file.uniqueIdentifier);
      if (index != -1) {
        this.filesUploadStatus[index].percent = 100;
        this.filesUploadStatus[index].status = 1;
        this.numCompletedUploads++;
        this.ngZone.run(() => this.filesUploadStatus = [...this.filesUploadStatus]);
      }
    });

    this.resumable.on('fileError', (file: ResumableFile) => {
      const index = this.filesUploadStatus.findIndex(f => f.fileId === file.uniqueIdentifier);
      if (index != -1) {        
        this.filesUploadStatus[index].status = 2;
        this.numErrorUploads++;
        this.ngZone.run(() => this.filesUploadStatus = [...this.filesUploadStatus]);
      }
    });
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle('Files Explorer', false);
    //this.getAllFiles();
    this.searchText = '';

    this.filesToUpload = [];

    this.filesClipboardService.onClipboardChanged$.subscribe((filesClipboard) => {
      if (filesClipboard !== null)
        this.hasClipboard = true;
      else
        this.hasClipboard = false;
    });
  }

  ngAfterViewInit() {
    this.activatedRoute.params.subscribe(params => {
      this.storageId = +params['id'];
      this.currentPath = [];
      let path: string = params['path']? params['path']: '/';
      let pathParts: string[] = path.split('/');
      let concatPath = '/';
      pathParts.forEach((dir) => {
        // skip empty dirs
        if (dir.length > 0) {
          concatPath += dir + '/';
          this.currentPath.push({path: concatPath, dirname: dir});
        }
      });
      this.getAllFiles();
      this.storageService.getById(this.storageId).subscribe((currentStorage)=> {
        this.currentStorageName = currentStorage.display_name;
        this.isGlobalStorage = (currentStorage.name == 'global');
        this.updatePermissions();
        this.isEcoDocsStorage = currentStorage.is_ecodocs_storage? true: false;
      });

      this.resumable.opts = this.fileService.getNewResumableConfigForStorage(this.storageId);
      this.resumable.opts.query = function (file: ResumableFile) {
        return file['extraQueryParams'];
      };
    });

    this.resumable.assignDrop(this.MyDropZone.nativeElement);

    this.fileClassService.list().subscribe((f) => {
      this.fileClasses = f;
      this.fileClasses.unshift(<FileClass>{
        name: '',
        required_metadata: [],
        optional_metadata: []
      });
      this.currentFileClass = this.fileClasses[0];  // select None as default
    });
  }

  authorizeExternalOperationsBeforeUpload() {
    if (!this.isEcoDocsStorage) {
      this.startUpload();
      return;
    }

    let uniqueFileClassesToUpload: FileClass[] = [];
    this.filesToUpload.forEach((f) => {
      if (!uniqueFileClassesToUpload.find((c) => c && c.name == f.fileClass)) {
        uniqueFileClassesToUpload.push(this.fileClasses.find((c) => c.name == f.fileClass));
      }
    });

    let connectedAppAuthsToAuthorize: ConnectedAppAuth[] = [];
    uniqueFileClassesToUpload.forEach((fileClass) => {
      if (fileClass) {
        (fileClass.external_operations || []).forEach((extOp) => {
          if (extOp.external_operation_common_settings.is_per_user_auth) {
            (extOp.external_operation_common_settings.auth_methods || []).forEach((authMethod) => {
              let connectedAppAuth: ConnectedAppAuth = JSON.parse(JSON.stringify(authMethod.connected_app_auth));
              connectedAppAuth.oauth2_scopes = (connectedAppAuth.oauth2_scopes || []).filter((scope) => (authMethod.oauth2_scopes || []).includes(scope.name));
              connectedAppAuthsToAuthorize.push(connectedAppAuth);
            });
          }
        });
      }
    });

    if (connectedAppAuthsToAuthorize.length == 0) {
      this.startUpload();
    } else {
      this.isCheckingExtOpAuth = true;
      this.authorizeApp.showIfNeedsAuthorization(connectedAppAuthsToAuthorize, false).pipe(finalize(() => this.isCheckingExtOpAuth = false)).subscribe((isAllAuthorized) => {
        if (isAllAuthorized) {
          this.startUpload();
        }
      });
    }
  }

  startUpload() {
    this.filesToUploadModal.hide();
    
    let lastDir = '/';
    if (this.currentPath.length != 0) {
      lastDir = trimEnd(this.currentPath[this.currentPath.length - 1].path, '/') + '/';
    }
    lastDir =  lastDir;

    this.filesToUpload.forEach((file) => {
      file.resumableFile['extraQueryParams'] = { path: lastDir, file_class: file.fileClass? file.fileClass: '', metadata: JSON.stringify(file.metadata? file.metadata: {}), should_overwrite: file.shouldOverwrite? 1: 0 };
      this.filesUploadStatus.push({ fileId: file.resumableFile.uniqueIdentifier, fileName: file.resumableFile.fileName, percent: 0, loaded: 0, status: 3 });
    });

    this.ngZone.run(() => this.filesUploadStatus = [...this.filesUploadStatus]);
    this.filesToUpload = [];

    this.resumable.upload();    
  }

  clearFilesToUpload() {
    this.filesToUpload.forEach((file) => {
      this.resumable.removeFile(file.resumableFile);
    });

    this.filesToUpload = [];
  }
  
  onEditMetadata(filesToEditMetadata: FileToUpload[]) {
    this.filesToUploadModal.hide();
    this.fileUploadMetadataEditor.show(filesToEditMetadata);
  }

  selectDeselectAllFilestoUpload(isChecked: boolean) {
    this.selectedFilesToUpload = (isChecked)? [...this.filesToUpload]: [];
  }

  selectDeselectAllFiles(isChecked: boolean) {
    this.selectedRows = (isChecked)? [...this.files]: [];
  }

  onRemoveFiles(filesToRemove: FileToUpload[]) {
    filesToRemove.forEach((file) => {
      this.resumable.removeFile(file.resumableFile);
    });

    this.filesToUpload = this.filesToUpload.filter((f) => {
      return filesToRemove.indexOf(f) == -1;
    });
  }

  innerWidth() {
    return window.innerWidth;
  }

  updateRightSideContextMenu() {
    this.comments = [];
    this.currentMetadata = null;
    this.isLoadingMetadata = false;
    
    //console.log(event)
    if (this.selectedRows.length > 1) {
      this.rightSideContext = this.muliSelectionOptions;
    }
    else if (this.selectedRows.length == 1) {
      if (this.selectedRows[0].type == 'Folder') {
        this.rightSideContext = this.folderOptions;
      }
      else {
        this.rightSideContext = this.fileOptions;
        let currentSelectedRow = this.selectedRows[0];
        this.fileService.getFileComment(this.storageId, this.selectedRows[0].path).subscribe(comments => {
          if (this.selectedRows.length == 1 && this.selectedRows[0] == currentSelectedRow)
            this.comments = comments;
        });

        if (this.isEcoDocsStorage) {
          if (this.filesMetadataCache[this.storageId + this.selectedRows[0].path]) {
            this.currentMetadata = this.filesMetadataCache[this.storageId + this.selectedRows[0].path];
            this.isLoadingMetadata = false;
          } else {
            this.loadSelectedFileMetadata();
          }
        }
      }
    } else {
      this.rightSideContext = [];
      this.comments = [];
      this.currentMetadata = null;
      this.isLoadingMetadata = false;
    }
  }
  onTableRowSelect(event) {
    this.updateRightSideContextMenu();
  }

  loadSelectedFileMetadata() {
    var currentSelectedRow = this.selectedRows[0];
    this.isLoadingMetadata = true;
    this.fileService.getMetadata(this.storageId, this.selectedRows[0].path).pipe(finalize(() => {
      this.isLoadingMetadata = false;
    })).subscribe(metadata => {
      // make sure selectedRows hasn't changed
      this.filesMetadataCache[this.storageId + currentSelectedRow.path] = metadata;
      if (this.selectedRows.length == 1 && this.selectedRows[0] == currentSelectedRow)
        this.currentMetadata = metadata;
    });
  }
  toggleContext(event) {
    if (event.type == 'body') {

      this.isContextOpen = false;

      if (!this.selectedRows.find(r => r == event.content))
        this.selectedRows.push(event.content)

      if (this.selectedRows.length > 1) {
        this.contextOptions = this.muliSelectionOptions
      }
      else {
        event.content.type == 'Folder' ? this.contextOptions = this.folderOptions : this.contextOptions = this.fileOptions;
      }
      /** @todo investigate why we need to subtract the header's height to get the correct Y */
      this.contextTop = event.event.pageY - 50; // 50 for the header height
      this.contextLeft = event.event.pageX;
      this.isContextOpen = true;
      event.event.preventDefault();
      event.event.stopPropagation();
    }
    // console.log(event)
  }

  onRightClick(event) {
    this.contextOptions = this.newFileOptions;
    this.contextTop = event.pageY;
    this.contextLeft = event.pageX;
    this.isContextOpen = true;
    //console.log(event)
    event.stopPropagation();
    event.preventDefault();
    return false;
  }

  toggleFileOverview(event, state, row) {
    if (state == true) {
      this.selectedRows = [row];
      this.onTableRowSelect(null)
    }
    event.stopPropagation();
    this.showFileOverView = state;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    this.isContextOpen = false;
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
  }

  selectAll() {
    this.selectedRows = this.files.slice();
  }

  deselectAll() {
    this.selectedRows = [];
  }

  invertSelection() {
    let tempSelectedRows = [];
    this.files.forEach(file => {
      if (!this.selectedRows.find(f => f == file)) {
        tempSelectedRows.push(file);
      }
    })
    this.selectedRows = tempSelectedRows;
  }

  canDeselect() {
    return this.selectedRows.length > 0;
  }

  canSelectAll() {
    return this.selectedRows.length != this.files.length;
  }

  canDelete() {
    return this.selectedRows.length > 0 && this.canDeletePermission;
  }

  canCopy() {
    return this.selectedRows.length > 0;
  }

  canMove() {
    return this.canCopy() && this.canDelete();
  }
  canPaste() {
    return this.canWritePermission && this.hasClipboard;
  }
  canEditMetadata() {
    return this.isEcoDocsStorage && this.canWritePermission && this.currentMetadata && this.selectedRows.length == 1 && this.selectedRows[0].type !== 'Folder';
  }
  
  canShare() {
    return this.selectedRows.length == 1 && this.selectedRows[0].type !== 'Folder';
  }

  canRename() {
    return this.canWritePermission && this.selectedRows.length == 1;
  }

  canCompress() {
    return this.canWritePermission && this.selectedRows.length > 0;
  }
  
  canShowVersions() {
    return this.canReadPermission && this.selectedRows.length == 1 && this.selectedRows[0].type !== 'Folder';
  }

  loadVersionHistory() {
    this.currentFileHistory = [];
    this.isLoadingVersionHistory = true;
    this.versionHistoryModal.show();
    this.fileService.listFileVersions(this.storageId, this.selectedRows[0].path).pipe(finalize(() => {
      this.isLoadingVersionHistory = false;
    })).subscribe((versions) => {
      this.currentFileHistory = versions;
    });
  }

  onRestoreVersion(fileVersion: FileVersion) {
    this.isLoadingVersionHistory = true;
    this.fileService.restoreFileVersion(this.storageId, this.selectedRows[0].path, fileVersion.version_id).pipe(finalize(() => {
      this.isLoadingVersionHistory = false;
      this.loadVersionHistory();
      this.refresh();
    })).subscribe();
  }

  viewOnlyFile(fileVersion: FileVersion) {
    let extension: string = this.selectedRows[0].extension.toLowerCase();
    /** @todo add images as well to this list? */
    if (extension == 'pdf') {
      window.open(this.fileService.directFileViewURLSpecificVersion(this.selectedRows[0].path, this.storageId, fileVersion.version_id), '_blank');
    } else if (this.wopiConfig[extension]) {
      this.isLoadingVersionHistory = true;
      this.wopiService.getFileWopiID(this.storageId, this.selectedRows[0].path, fileVersion.version_id, true).pipe(finalize(() => {
        this.isLoadingVersionHistory = false;
      })).subscribe((id) => {
        window.open(`/wopi/view/${extension}/${id}`, '_blank');
      });
    } else {
      this.fileService.downloadFileSpecificVersion( this.selectedRows[0].path, this.storageId, fileVersion.version_id);
    }
  }

  minimizeModal() {
    if (!this.fileUploadingModal.isShown)
      this.fileUploadingModal.show();
    else {
      this.fileUploadingModal.hide();

    }
  }

  confirmCancelUpload() {
    if (this.fileUploadingModal.isShown)
      this.fileUploadingModal.hide();

    this.cancelUploadConfirmationModal.show();
  }

  cancelUpload() {
    this.cancelUploadConfirmationModal.hide();
    this.fileUploadingModal.hide();
    this.numCompletedUploads = 0;
    this.numErrorUploads = 0;
    this.totalUploadedPercent = 0;
    this.filesUploadStatus = [];

    this.resumable.cancel();
  }

  onErrLoadIcon(e: Event) {
    e.srcElement["src"] = "/assets/img/file-icons/unknown.png";
  }

  getAllFiles() {
    this.filesLoadingIndicator = true;

    let lastDir = '/';
    if (this.currentPath.length != 0) {
      lastDir = this.currentPath[this.currentPath.length - 1].path;
    }

    if (lastDir.substr(lastDir.length - 1) != '/') {
      lastDir += '/';
    }

    this.updatePermissions();

    // update the current path in the url
    this.router.navigateByUrl(this.router.createUrlTree(['file-explorer', this.storageId, lastDir], {}));

    this.fileService.getAll( lastDir, this.storageId).subscribe((response: MyFile[]) => {
      this.files = response;
      this.filesLoadingIndicator = false;
      this.selectedRows = [];
      this.filesMetadataCache = {};
    }, err => {
      this.toastService.error('Error listing files!');
    });
  }

  updatePermissions() {
    let lastDir = '/';
    if (this.currentPath.length != 0) {
      lastDir = this.currentPath[this.currentPath.length - 1].path;
    }

    if (lastDir.substr(lastDir.length - 1) != '/') {
      lastDir += '/';
    }
    setTimeout(() => {
      this.canDeletePermission = !this.isGlobalStorage || this.userService.canForPath('super.admin.files.all.delete', lastDir);
      this.canWritePermission = !this.isGlobalStorage || this.userService.canForPath('super.admin.files.all.delete.write', lastDir);
      this.canReadPermission = !this.isGlobalStorage || this.userService.canForPath('super.admin.files.all.delete.write.read', lastDir); 
      
      if (this.canWritePermission) {
        this.resumable.assignDrop(this.MyDropZone.nativeElement);
      } else {
        this.resumable.unAssignDrop(this.MyDropZone.nativeElement);
      }
    }, 1);
  }
  getSelectedFileLocation() {
    const lastseparator = this.currentPath.length > 0 ? ' > ' : '';
    return this.currentStorageName + ' > ' + this.currentPath.map(p => p.dirname).join(' > ') + lastseparator + this.selectedRows[0].filename;
  }

  // open specific folder from current path (my files > folder1 > folder2)
  openParentFolder(folder: { path: string, dirname: string }) {
    const index = this.currentPath.findIndex(p => p.path == folder.path && p.dirname == folder.dirname);

    if (index > -1) {
      this.currentPath.splice(index + 1);
    }

    this.getAllFiles();
  }

  // open folder when user pressed right click on folder and then choose open
  onFolderRightClickOpen() {
    const dir = <MyFile>this.selectedRows.pop();
    this.currentPath.push({ dirname: dir.filename, path: dir.path });
    this.getAllFiles();
  }

  openRootFolder() {
    this.currentPath.splice(0);
    this.getAllFiles();
  }

  clearSelection() {
    if (window.getSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
    }
  }

  onactivate(event: any) {
    if (event.type == "click") {
      const row = <MyFile>event.row;
      this.clearSelection();

      // open folder on double click
      if (row.type === 'Folder') {
        if (!this.filesLoadingIndicator) {
          this.selectedRows = [];
          this.currentPath.push({ path: row.path, dirname: row.filename });
          this.getAllFiles();
        }
      } else {
        // it's a file, default action for file is download or open if it's a PDF
        /** @todo open PDFs with our editor */
        let extension: string = row.extension.toLowerCase();
        /** @todo make sure PDF is enabled for this client */
        /*if (extension == 'pdf') {
          window.open(`/pdf/${this.storageId}/${encodeURIComponent(row.path)}`, '_blank');
        } else */if (this.wopiConfig[extension]) {
          let actionName: string = null;
          if (this.wopiConfig[extension]['edit'] && this.canWritePermission) {
            actionName = 'edit';
          } else if (this.wopiConfig[extension]['convert'] && this.canWritePermission) {
            actionName = 'convert';
          } else if (this.wopiConfig[extension]['view']) {
            actionName = 'view';
          } 
          
          /* what is open?? 
          else if (this.wopiConfig[extension]['open']) {
          } */

          this.filesLoadingIndicator = true;
          this.wopiService.getFileWopiID(this.storageId, row.path).pipe(finalize(() => {
            this.filesLoadingIndicator = false;
          })).subscribe((id) => {
            window.open(`/wopi/${actionName}/${extension}/${id}`, '_blank');
          });
        } else {
          this.fileService.downloadFile( row.path, this.storageId);
        }
      }
    }
  }

  openFileDialog() {
    const uploader = this.fileInput.nativeElement as HTMLElement;
    uploader.click();
  }

  onUploadFiles(files: File[]) {

    const fileArray = Array.from<File>(files);

    fileArray.forEach((file: File, index: number) => {
      this.resumable.addFile(file, undefined);
    });

    /** @note This timeout is a work-around, if upload is called directly, the upload
     * doesn't start for some reason.
     */
    // setTimeout(() => {
    //   this.resumable.upload();
    // }, 1);

    this.fileInput.nativeElement.value = '';
  }

  onAddNewFolder() {
    if (!this.createNewFolderForm.valid) {
      this.validationHandler.onSubmitCheck(this.createNewFolderForm);
      return;
    }
    const path =  (this.currentPath.length > 0 ? this.currentPath[this.currentPath.length - 1].path : "/");

    this.isCreatingFolder = true;
    this.fileService.createFolder(this.createNewFolderForm.controls["folder_name"].value, path, this.storageId).pipe(finalize(() => {
      this.isCreatingFolder = false;
    })).subscribe(() => {
      this.getAllFiles();
      this.createFolderModal.hide();
      this.createNewFolderForm.reset();
    }, err => {
      this.validationHandler.serverValidationHandler(err, this.createNewFolderForm);
    });
  }

  deleteSelected() {
    if (this.selectedRows.length > 0) {
      this.filesLoadingIndicator = true;
      const observables: Observable<any>[] = []
      this.selectedRows.forEach(file => {
        if (file.type === 'Folder') {
          observables.push(this.fileService.deleteFolder( file.path, this.storageId));
        } else if (file.type === 'file') {
          observables.push(this.fileService.deleteFile( file.path, this.storageId));
        }
      });

      forkJoin(observables).subscribe(() => {
        // clear selection
        this.selectedRows = [];
        this.getAllFiles();
      }, err => {
        this.filesLoadingIndicator = false;
        this.toastService.error('Error Deleting File(s)!');
        // clear selection
        this.selectedRows = [];
      });
    }
  }

  onMoveOrCopyFile(op_name: string) {

    this.filesClipboardService.setClipboard(op_name, this.storageId, this.selectedRows);

    if (op_name === 'cut') {
      this.toastService.success(`${this.selectedRows.length} Item(s) Cut!`);
    } else if (op_name === 'copy') {
      this.toastService.success(`${this.selectedRows.length} Item(s) Copied!`);
    }

    //this.hasClipboard = true;
    this.selectedRows = [];
  }
  refresh()
  {
    this.getAllFiles()
    this.selectedRows = [];
  }

  onPasteFile() {
    let filesClipboard: Clipboard = this.filesClipboardService.getClipboard();

    if (filesClipboard && filesClipboard.clipboardItems.length > 0) {
      this.filesLoadingIndicator = true;

      const currentPath = this.currentPath.length > 0 ? trimEnd(this.currentPath[this.currentPath.length - 1].path, '/') + '/' : '/';

      let pasteObservables: Observable<any>[] = [];
      const isCut: boolean = filesClipboard.operation_name === 'cut';

      filesClipboard.clipboardItems.forEach((clipboardItem) => {
        const filename = clipboardItem.path.substring(clipboardItem.path.lastIndexOf('/') + 1);

        if (isCut) {
          if (clipboardItem.type === 'file') {
            pasteObservables.push(this.fileService.moveFile( clipboardItem.path, currentPath +  filename, clipboardItem.storageId, this.storageId));
          } else {
            pasteObservables.push(this.fileService.moveFolder( clipboardItem.path, currentPath +  filename, clipboardItem.storageId, this.storageId));
          }
        } else {
          if (clipboardItem.type === 'file') {
            pasteObservables.push(this.fileService.copyFile( clipboardItem.path, currentPath +  filename, clipboardItem.storageId, this.storageId));
          } else {
            pasteObservables.push(this.fileService.copyFolder( clipboardItem.path, currentPath +  filename, clipboardItem.storageId, this.storageId));
          }
        }
      });

      forkJoin(pasteObservables).subscribe(() => {
        this.refresh();
      }, (err) => {
        this.filesLoadingIndicator = false;
        this.toastService.error('Error Pasting File(s)!');
        this.refresh();
      });

      if (filesClipboard.operation_name === 'cut') {
        this.filesClipboardService.clearClipboard();
      }
    }
  }

  showDeleteConfirmation() {
    if (this.selectedRows.length > 0) {
      this.deleteConfirmationModal.show();
    }
  }
  onDeleteFile() {
    this.deleteConfirmationModal.hide();
    this.deleteSelected();
  }

  onDownloadFile() {
    this.selectedRows.forEach((item: MyFile, index: number) => {
      //setTimeout(() => this.fileService.downloadFile( item.path, this.storageId), (index + 1) * 1000);
      if (item.type === 'Folder')
        this.fileService.downloadFolder( item.path, this.storageId);
      else
        this.fileService.downloadFile( item.path, this.storageId)
    });
  }

  onFileRenaming() {
    this.renameFileModal.show();
    this.renameFileForm.controls['dest_path'].setValue(this.selectedRows[0].filename);
  }

  showCompressModal() {
    this.createZipModal.show();
  }

  onCompress() {
    if (!this.createNewZipForm.valid) {
      this.validationHandler.onSubmitCheck(this.createNewZipForm);
      return;
    }

    const currentPath = this.currentPath.length > 0 ? trimEnd(this.currentPath[this.currentPath.length - 1].path, '/') + '/' : '/';
    let zipPath = currentPath +  this.createNewZipForm.controls['zip_path'].value;

    const lastDotIndex = zipPath.lastIndexOf('.');
    const extension = lastDotIndex > -1 ? zipPath.substring(zipPath.lastIndexOf('.')) : '.zip';
    zipPath = zipPath + extension;

    this.isCreatingZip = true;

    const paths: string[] = this.selectedRows.map((f) => { return f.path });

    this.fileService.createZip(zipPath, paths, this.storageId).pipe(finalize(() => {
      this.isCreatingZip = false;
    })).subscribe(() => {
      this.getAllFiles();
      this.createNewZipForm.reset();
      this.selectedRows = [];
      this.createZipModal.hide();
    }, err => {
      this.validationHandler.serverValidationHandler(err, this.createNewZipForm);
    });
  }

  isDate(value: any) : boolean {
    return value instanceof Date;
  }

  onRenameFile() {
    if (!this.renameFileForm.valid) {
      this.validationHandler.onSubmitCheck(this.renameFileForm);
      return;
    }

    const currentPath = this.currentPath.length > 0 ?  trimEnd(this.currentPath[this.currentPath.length - 1].path, '/') + '/' : '/';
    const filePath = this.selectedRows[0].path;

    this.isRenamingFolder = true;
    if (this.selectedRows[0].type === 'file') {
      const lastDotIndex = filePath.lastIndexOf('.');
      const extension = lastDotIndex > -1 ? filePath.substring(filePath.lastIndexOf('.')) : '';

      this.fileService.moveFile( filePath, currentPath +  this.renameFileForm.controls['dest_path'].value + extension, this.storageId, this.storageId).pipe(finalize(() => {
        this.isRenamingFolder = false;
      })).subscribe(() => {
        this.getAllFiles();
        this.renameFileForm.reset();
        this.selectedRows = [];
        this.renameFileModal.hide();
      }, err => {
        this.validationHandler.serverValidationHandler(err, this.renameFileForm);
      });
    }
    else {
      this.fileService.moveFolder( filePath, currentPath +  this.renameFileForm.controls['dest_path'].value, this.storageId, this.storageId).pipe(finalize(() => {
        this.isRenamingFolder = false;
      })).subscribe(() => {
        this.getAllFiles();
        this.renameFileForm.reset();
        this.selectedRows = [];
        this.renameFileModal.hide();
      }, err => {
        this.validationHandler.serverValidationHandler(err, this.renameFileForm);
      });
    }
  }

  viewOCRText() {
    this.isLoadingTextContent = true;
    this.ocrTextContent = '';
    this.fileService.getText(this.selectedRows[0].path, this.storageId).pipe(finalize(() => {
      this.isLoadingTextContent = false;
    })).subscribe((t) => {
      this.ocrTextContent = t.text;
      this.ocrTextModal.show();
    }, () => {
      this.toastService.error('Error getting recognized text for this file.');
    });
  }
  showFileUploadingModalIfUploading() {
    if (this.filesUploadStatus && this.filesUploadStatus.length > 0) {
      this.fileUploadingModal.show();
    }
  }
  onEditExistingMetadata() {
    /** @todo */
    this.filesToEditMetadata = [];
    (this.selectedRows || []).forEach((f) => {
      this.filesToEditMetadata.push({
        path: f.path,
        metadata: this.filesMetadataCache[this.storageId + f.path],
        fileClass: this.filesMetadataCache[this.storageId + f.path]? <string>(this.filesMetadataCache[this.storageId + f.path]['file_class']): null
      })
    });
    this.existingFilesMetadataEditor.show(this.filesToEditMetadata);
  }
  onSavedExistingMetadata() {
    this.filesLoadingIndicator = true;
    this.currentMetadata = null;
    this.isLoadingMetadata = true;
    this.fileService.postMetadata(this.storageId, this.filesToEditMetadata.flatMap((s) => s.path), 
                                  this.filesToEditMetadata[0].fileClass,
                                  this.filesToEditMetadata[0].metadata).pipe(finalize(() => {
                                    this.filesLoadingIndicator = false;
                                    if (this.selectedRows.length == 1) {
                                      this.loadSelectedFileMetadata();
                                    } else {
                                      this.isLoadingMetadata = false;
                                    }
                                  })).subscribe(
      () => {
        this.toastService.success('Updated Metadata!');
        this.filesMetadataCache = {};
      },
      (err) => {
        this.toastService.error('Error updating metadata!');
        this.filesMetadataCache = {};
      }
    );
  }
  ngOnDestroy() {

  }

  beginSearch() {
    if (this.currentStorageName == 'Global') {
      this.router.navigate(['/search'], {queryParams: {
        options: JSON.stringify({
            query: this.searchText,
            is_files: true,
            is_user_storage: false,
            is_global_storage: true,
            in_file_contents: this.searchInContent,
            is_forms: false,
            in_form_contents: false,
            global_storage_folders: (this.currentPath.length)? [{path: this.currentPath[this.currentPath.length - 1].path}]: [],
            is_data: false
        })
      }});
    } else if (this.currentStorageName == 'Private') {
      this.router.navigate(['/search'], {queryParams: {
        options: JSON.stringify({
            query: this.searchText,
            is_files: true,
            is_user_storage: true,
            is_global_storage: false,
            in_file_contents: this.searchInContent,
            is_forms: false,
            in_form_contents: false,
            user_storage_folders: (this.currentPath.length)? [{path: this.currentPath[this.currentPath.length - 1].path}]: [],
            is_data: false
        })
      }});
    }
  }

  columnComparator(value1: any, value2: any, file1: File, file2: File) {
    let isFile1Folder: boolean = file1.type === 'Folder';
    let isFile2Folder: boolean = file2.type === 'Folder';

    if (isFile1Folder && !isFile2Folder) {
      return -1;
    } else if (!isFile1Folder && isFile2Folder) {
      return 1;
    }

    if (value1.toLowerCase || value2.toLowerCase)
      return value1.toLowerCase().localeCompare(value2.toLowerCase());
    else
      return (value1 > value2) ? 1 : -1;
  }

  onFocus(event) {
    if(event.oldRange == null){
      this.hideQuillToolbar = false;
    }
  }
  onBlur() {
    this.commentEditor.quill.setContents([]);
    this.hideQuillToolbar = true;
    this.updatecomment = false;
  }

  submitFileComment() {
    //Add Mode
    if (!this.updatecomment) {
      let comment = {} as FileComment;
      comment.comment = this.addComment;
      comment.path = this.selectedRows[0].path;
      comment.storage_id = this.storageId;
      this.fileService.addFileComment(comment).pipe(finalize(() => {

      })).subscribe(t => {
        this.comments.push(t);
        this.addComment = "";
      });
    }
    //Edit mode
    else {

      this.selectedcomment.comment = this.addComment;
      this.selectedcomment.updated_at = 'edited';
      this.fileService.UpdateFileComment(this.selectedcomment).pipe(finalize(() => {

      })).subscribe(t => {
        this.comments.find(x => x.id == this.selectedcomment.id).comment == t.comment;
        this.addComment = "";
        this.selectedcomment = {};
        this.updatecomment = false;
      });;
    }
  }
  UpdateComment(comment: FileComment) {
    this.addComment = comment.comment;
    this.selectedcomment = comment;
    this.updatecomment = true;
    this.hideQuillToolbar = false;
  }
  Deletecomment(id: number) {
    this.fileService.deleteFileComment(this.storageId, id).pipe(finalize(() => {

    })).subscribe(t => {
      let index = this.comments.findIndex(x => x.id == id);
      this.comments.splice(index, 1);
    });

  }
  modulesOptions;
  toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],        // toggled buttons , 'strike'
    [{ 'color': [] }],          // dropdown with defaults from theme
    ['image']
    // [{ 'size': ['small', 'normal', 'large', 'huge'] }],  // custom dropdown
    // [{ 'font': [] }],
    // [{ 'align': [] }],
    // ['blockquote', 'code-block'],

    // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    // [{ 'direction': 'rtl' }],                         // text direction



    // ['clean']
  ];
}
